import { styled } from "@mui/material";
import { InfoSnackBar } from "components/InfoSnackBar";
import { Assignment } from "helpers/assignment";
import { useState } from "react";
import { getPath as getRoutePath, routes } from "routes";
import { AssignmentModelListItem } from "./AssignmentModelListItem";

const PREFIX = "AssignmentsDashboardPageList";

const classes = {
	root: `${PREFIX}-root`,
	paper: `${PREFIX}-paper`,
	table: `${PREFIX}-table`,
};

const Root = styled("div")(({ theme }) => ({
	[`&.${classes.root}`]: {
		width: "100%",
		marginLeft: theme.spacing(1),
	},

	[`& .${classes.paper}`]: {
		width: "100%",
		marginBottom: theme.spacing(2),
	},

	[`& .${classes.table}`]: {
		marginBottom: theme.spacing(4),
	},
}));

export interface AssignmentModelListProps {
	assignments: Assignment[];
	getPath?: (assignmentId: string) => string;
	show_csv: boolean;
}

const defaultGetPath = (assignmentId: string): string =>
	getRoutePath(routes._.assignments._.view, { assignmentId });

export const AssignmentModelList = ({
	assignments,
	getPath = defaultGetPath,
	show_csv,
}: AssignmentModelListProps): JSX.Element => {
	const [err, setErr] = useState("");

	return (
		<Root className={classes.root}>
			{assignments.map((row, index) => {
				const labelId = `assignment-${index}`;

				return (
					<div className={classes.table} key={row.assignmentId}>
						<AssignmentModelListItem
							assignment={row}
							labelId={labelId}
							getPath={getPath}
							setErr={setErr}
							show={show_csv}
						/>
					</div>
				);
			})}
			<InfoSnackBar
				isOpen={err !== ""}
				onClose={() => setErr("")}
				message={err}
				severity="error"
			/>
		</Root>
	);
};
